import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AleaControlShell from "../../../communication/AleaControlShell";
import { CreateTicketCodes, GameTypeEnum } from "../../../enums";
import {
  setCredit,
  setIsBettingEnabled,
  setWin,
} from "../../../store/config-slice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setCarouselNumber } from "../../../store/picks/carousel-slice";
import {
  setDrawTab,
  setIsDrawInProgress,
  switchTab,
} from "../../../store/picks/tabs-slice";
import {
  clearAllUserPicks,
  setShouldShowYourPick,
  setTicketIdentification,
} from "../../../store/picks/userPick-slice";
import store from "../../../store/store";
import { setWinningNumber } from "../../../store/wheel-slice";
import { createTicket } from "../../../utils/TicketUtils";
import Countdown from "../../BettingPanel/CountdownOverlay/Countdown";
import ModalMessage from "../ModalMessage/ModalMessage";

import FooterButton from "./FooterButton";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [shouldStartDraw, setShouldStartDraw] = useState(false);
  const [infoModalMessage, setInfoModalMessage] = useState("");
  const gameType = useAppSelector((state) => state.config.gameType);

  const createTicketHandler = async (): Promise<void> => {
    const createTicketResponse = await createTicket();

    setShouldStartDraw(false);

    if (createTicketResponse.successCode === CreateTicketCodes.SUCCESS) {
      if (gameType === GameTypeEnum.ONLINE) {
        dispatch(setCredit({ balance: createTicketResponse.balance }));
        dispatch(setWinningNumber(createTicketResponse.drawnNumber));
        dispatch(setCarouselNumber(createTicketResponse.multiplier));
        dispatch(setShouldShowYourPick(true));
        if (
          createTicketResponse.payOutSum &&
          createTicketResponse.payOutSum > 0
        ) {
          dispatch(setWin(createTicketResponse.payOutSum));
        }

        dispatch(setDrawTab(true));
      } else if (gameType === GameTypeEnum.PANEL) {
        AleaControlShell.sendPresentationEvent(
          "BergmannRoulette",
          JSON.stringify({
            drawnNumber: createTicketResponse.drawnNumber,
            carouselMultiplier: createTicketResponse.multiplier,
          })
        );

        AleaControlShell.refreshBalance();

        if (
          createTicketResponse.payOutSum &&
          createTicketResponse.payOutSum > 0
        ) {
          dispatch(setWin(createTicketResponse.payOutSum));
        }
        dispatch(setWinningNumber(createTicketResponse.drawnNumber));
        dispatch(
          setTicketIdentification(
            createTicketResponse.ticketItem?.ticketIdentification
          )
        );
        dispatch(setIsDrawInProgress(true));
      }
    } else if (
      createTicketResponse.successCode === CreateTicketCodes.OUT_OF_MONEY
    ) {
      setInfoModalMessage("message.outOfMoney");
    } else if (createTicketResponse.successCode === CreateTicketCodes.ERROR) {
      setInfoModalMessage("message.genericError");
    } else if (
      createTicketResponse.successCode === CreateTicketCodes.BETTING_DISABLED
    ) {
      dispatch(setIsBettingEnabled(false));
    } else if (
      createTicketResponse.successCode === CreateTicketCodes.MAX_STAKE_REACHED
    ) {
      setInfoModalMessage("message.maxStakeReached");
    }
  };

  return (
    <>
      <footer className="shellPanel">
        <FooterButton
          text={t("footer.delete")}
          styleClass="delete"
          onButtonClick={() => dispatch(clearAllUserPicks())}
        />

        {gameType === GameTypeEnum.ONLINE && (
          <FooterButton
            text={t("footer.draw")}
            styleClass=""
            onButtonClick={() => {
              dispatch(switchTab());
            }}
          />
        )}
        <FooterButton
          text={t("footer.play")}
          styleClass="play active"
          onButtonClick={() => {
            if (store.getState().picks.pickedStakes.length > 0) {
              setShouldStartDraw(true);
            }
          }}
        />
      </footer>
      {infoModalMessage !== "" && (
        <ModalMessage
          message={infoModalMessage}
          onApprove={() => setInfoModalMessage("")}
        />
      )}
      {shouldStartDraw && (
        <Countdown
          cancelDrawStart={setShouldStartDraw}
          createTicket={createTicketHandler}
        />
      )}
    </>
  );
};

export default Footer;
